import "../PersonalInfoAgreementTrans/personal-info-agree-trans.css";

const PersonalInfoTrans = () => {
  return (
    <div className="document_area">
      <span className="document_area_title">Согласие на обработку персональных данных</span>
      <span>
        Пользователи, которые используют сервисы Сайта, включая, но не ограничиваясь, веб-сайтом, мобильными
        приложениями и другими цифровыми платформами, в соответствии со статьей 9 Федерального закона от 27.07.2006 N
        152-ФЗ «О персональных данных» дают конкретное, предметное, информированное, сознательное и однозначное согласие
        на обработку своих персональных данных Индивидуальному предпринимателю Байкину О.Н. ИНН 503820178872, ОГРНИП
        326508100513422 от 01.09.2026 года (далее — оператор), находящемуся по адресу: Центральный, д. 7, кв./оф. 40,
        Московская область, р-н Пушкино, г. Ивантеевка, baikin_98@mail.ru, с целями:
      </span>
      <span>- Идентификации Пользователя, зарегистрированного на Сайте.</span>
      <span>- Предоставления Пользователю доступа к персонализированным ресурсам Сайта.</span>
      <span>
        - Установления с Пользователем обратной связи, включая направление уведомлений, запросов, касающихся
        использования Сайта, оказания услуг, обработку запросов и заявок от Пользователя.
      </span>
      <span>
        - Определения места нахождения Пользователя для обеспечения безопасности, предотвращения мошенничества.
      </span>
      <span>- Подтверждения достоверности и полноты персональных данных, предоставленных Пользователем.</span>
      <span>Перечень моих персональных данных, на обработку которых я даю согласие:</span>
      <span style={{ lineHeight: "25px" }}>
        {"- VIN номер автомобиля, марка и модель автомобиля"}
        <br />
        {"- государственный регистрационный знак автомобиля"}
        <br />
        {"- пробег автомобиля"}
        <br />
        {"- фамилия"}
        <br />
        {"- имя"}
        <br />
        {"- отчество (при наличии)"}
        <br />
        {"- год рождения"}
        <br />
        {"- месяц рождения"}
        <br />
        {"- дата (день) рождения"}
        <br />
        {"- гражданство"}
        <br />
        {"- адрес регистрации и фактического проживания, если отличается от адреса регистрации"}
        <br />
        {
          "- данные документа, удостоверяющего личность (серия, номер паспорта, дата и кем выдан паспорт, код подразделения)"
        }
        <br />
        {
          "- данные, которые автоматически передаются сервисам Сайта в процессе их использования с помощью установленного на устройстве Пользователя программного обеспечения, в том числе IP-адрес"
        }
        <br />
        {"- данные файлов cookie"}
        <br />
        {
          "- информация о браузере Пользователя (или иной программе, с помощью которой осуществляется доступ к сервисам)"
        }
        <br />
        {"- технические характеристики оборудования и программного обеспечения, используемых Пользователем"}
        <br />
        {"- дата и время доступа к сервисам, адреса запрашиваемых страниц и иная подобная информация"}
        <br />
        {"- номер телефона"}
        <br />
        {"- адрес электронной почты"}
        <br />
        {"- сведения о приобретённых или заказанных услугах и товарах"}
        <br />
        {
          "- статус взаимодействия (в том числе: произведена ли оплата, подобран ли автомобиль, совершена ли покупка, отказался ли клиент от сделки и иные статусы)."
        }
      </span>
      <span>
        Разрешаю оператору производить автоматизированную, а также осуществляемую без использования средств
        автоматизации обработку моих персональных данных, а именно: сбор, запись, систематизацию, накопление, хранение,
        уточнение (обновление, изменение), извлечение, использование, передачу (предоставление, доступ), обезличивание,
        блокирование, удаление, уничтожение.
      </span>
      <span>
        В отношении персональной информации Пользователя сохраняется ее конфиденциальность, кроме случаев добровольного
        предоставления Пользователем информации о себе для общего доступа неограниченному кругу лиц. При использовании
        отдельных сервисов Пользователь соглашается с тем, что определенная часть его персональной информации становится
        общедоступной, а именно информация, отмеченная в таблице значком *.
      </span>
      <span>
        Согласие действует до его отзыва. Субъект персональных данных вправе отозвать настоящее согласие на обработку
        своих персональных данных, письменно уведомив об этом оператора по адресу электронной почты: baikin_98@mail.ru.
      </span>
    </div>
  );
};

export default PersonalInfoTrans;
